import { render, staticRenderFns } from "./DesignTemplates.vue?vue&type=template&id=0d83cb92"
import script from "./DesignTemplates.vue?vue&type=script&lang=js"
export * from "./DesignTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports